'use client'

import { Suspense } from 'react'
import dynamic from 'next/dynamic'
import LoadingFallback from '@/travelmde/components/Common/LoadingFallback'

const DynamicShowOnMap = dynamic(() => import('@/travelmde/components/Home/ShowOnMap'), {
  'use client': true,
  loading: () => <LoadingFallback />,
  ssr: false,
})

const MapSection = ({ lang, fetchObject }) => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <div className="pt-4">
        <DynamicShowOnMap lang={lang} fetchObject={fetchObject} />
      </div>
    </Suspense>
  )
}

export default MapSection
